import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import filter from 'lodash/filter';
import DraggableList from 'react-draggable-list';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { Paper, Icon } from 'components';
import CardOption from './components/CardOption/CardOption';
import styles from './CardOptions.scss';

const CardOptions = ({
    addButtonText,
    isDisabled,
    onChange,
    options,
    newOptionPlaceholder
}) => {
    const addItem = () => {
        const newItem = { value: uuid(), display: '' };
        onChange([...options, newItem]);
    };

    const editItem = (newDisplay, editedOption) => {
        const newList = options.map(option => {
            if (option.value === editedOption.value) {
                return { value: option.value, display: newDisplay };
            }

            return option;
        });
        onChange(newList);
    };

    const deleteItem = (deletedItem) => {
        const newList = filter(options, option => option.value !== deletedItem.value);
        onChange(newList);
    };

    const handleReorder = (newList) => {
        onChange(newList);
    };

    return (
        <Paper
            square
            elevation={1}
            className={styles.menu}
        >
            <List>
                <DraggableList
                    list={options}
                    itemKey='value'
                    onMoveEnd={handleReorder}
                    template={CardOption}
                    commonProps={{
                        onEdit: editItem,
                        onDelete: deleteItem,
                        disabled: isDisabled,
                        placeholder: newOptionPlaceholder
                    }}
                />
                <ListItem
                    button
                    onClick={addItem}
                    disabled={isDisabled}
                    className={styles.addButton}
                    aria-label={addButtonText}
                >
                    <Icon name='ion-md-add' />{ addButtonText }
                </ListItem>
            </List>
        </Paper>
    );
};

CardOptions.propTypes = {
    addButtonText: PropTypes.string,
    newOptionPlaceholder: PropTypes.string,
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.shape({
        display: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    }))
};

CardOptions.defaultProps = {
    newOptionPlaceholder: 'New Item',
    addButtonText: 'Add item',
    isDisabled: false,
    onChange: () => {},
    options: []
};


export default CardOptions;
